import { render, staticRenderFns } from "./kpiCompanyTable.vue?vue&type=template&id=4c6440e5"
import script from "./kpiCompanyTable.vue?vue&type=script&lang=js"
export * from "./kpiCompanyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports